import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "text-center text-gray-lp-300 xxl:text-16px px-12 mb-5" }, " Scan QR Code di atas atau Anda juga bisa membagikan Link ", -1)
const _hoisted_2 = { class: "text-center text-gray-lp-300" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "font-bold text-20px" }, "Mau Bagikan Lewat Mana?", -1)
const _hoisted_4 = { class: "flex flex-wrap gap-8 justify-center pt-4" }
const _hoisted_5 = { class: "items-center flex flex-col xxl:text-14px" }
const _hoisted_6 = {
  class: "\n              rounded-full\n              border border-gray-lp-1300\n              flex\n              items-center\n              justify-center\n              p-3\n              mb-1\n              cursor-pointer\n            ",
  style: {"height":"75px","width":"75px"}
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" WhatsApp ")
const _hoisted_8 = { class: "items-center flex flex-col xxl:text-14px" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Salin Link ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_SnackbarCopy = _resolveComponent("SnackbarCopy")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("a", {
            href: `https://api.whatsapp.com/send?text=${_ctx.whatsAppDetail}`,
            target: "_blank"
          }, [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_Icons, {
                name: "whatsapp-outline",
                width: "26",
                height: "26",
                class: "text-green-lp-100"
              })
            ])
          ], 8, ["href"]),
          _hoisted_7
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", {
            class: "\n            rounded-full\n            border border-gray-lp-1300\n            flex\n            items-center\n            justify-center\n            cursor-pointer\n            p-3\n            mb-1\n          ",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.autoCopyLink && _ctx.autoCopyLink(...args))),
            style: {"height":"75px","width":"75px"}
          }, [
            _createVNode(_component_Icons, {
              name: "chain",
              width: "26",
              height: "26"
            })
          ]),
          _hoisted_9
        ])
      ])
    ]),
    _createVNode(_component_SnackbarCopy, {
      "model-value": _ctx.copyNotification,
      "onUpdate:modelValue": _ctx.removeCopyNotification
    }, null, 8, ["model-value", "onUpdate:modelValue"])
  ], 64))
}